import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { Container } from '@/features/_components/ui/container'
import { useApplicationParams } from '@/features/_hooks/use-application-params'
import { queries } from '@/features/_lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { EditProvider } from '../../../_providers/edit'
import { GuarantorHeader } from '../../_components/guarantor-header'
import { GuarantorProfileForm } from '../_components/guarantor-profile-form'
import { GuarantorProfileSkeleton } from '../_components/guarantor-profile.skeleton'
import { FormProvider } from './_providers/form'

const GuarantorProfile = ({ session }: WithAuthComponentProps) => {
  const { companyId, facilityId, applicationId } = useApplicationParams()
  const { guarantorId } = useParams({ strict: false }) as { guarantorId: string }

  const { data: application } = useQuery({
    ...queries.applications.detail(companyId, facilityId, applicationId),
    enabled: !!companyId && !!facilityId,
  })

  const { data: guarantor } = useQuery({
    ...queries.persons.detail(companyId, guarantorId),
    enabled: !!companyId,
  })
  const { data: company } = useQuery({
    ...queries.companies.detail(application?.companyId ?? ''),
    enabled: !!application?.companyId,
  })
  const { data: person } = useQuery({
    ...queries.persons.detail(companyId ?? '', application?.personId ?? ''),
    enabled: !!companyId && !!application?.personId,
  })

  if (!guarantor || !application || !company || !person) return <GuarantorProfileSkeleton />

  return (
    <EditProvider>
      <FormProvider guarantor={guarantor}>
        <Container className="h-full px-14 py-10 gap-6">
          <GuarantorHeader
            application={application}
            company={company}
            person={person}
            guarantor={guarantor}
            userType={session.user.userType}
          />
          <GuarantorProfileForm guarantor={guarantor} companyId={application.companyId} />
        </Container>
      </FormProvider>
    </EditProvider>
  )
}

export default WithAuth(GuarantorProfile, {
  allowedFor: ['staff', 'tenant'],
})
